import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import config from './config';
import reportWebVitals from './reportWebVitals';
import { AuthProvider } from "react-oidc-context";
import { cognitoAuthConfig } from './authConfig';
import { Amplify } from 'aws-amplify';

Amplify.configure({
  Auth: {
    Cognito: {
      userPoolId: config.cognito.userPoolId,
      userPoolClientId: config.cognito.userPoolClientId,
      loginWith: {
        email: true,
        oauth: {
          domain: config.cognito.domain,
          scopes: config.cognito.scopes,
          redirectSignIn: config.cognito.redirectSignIn,
          redirectSignOut: config.cognito.redirectSignOut,
          responseType: config.cognito.responseType
        }
      }
    }
  }
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    {/* Se usi Amplify per tutto, AuthProvider potrebbe non servirti più, 
        ma lo lasciamo se lo usi in altre parti dell'app */}
    <AuthProvider {...cognitoAuthConfig}>
      <App />
    </AuthProvider>
  </React.StrictMode>
);

reportWebVitals();